module.exports = __webpack_public_path__ + "static/media/paper.3bc5b0b1.png";